import Page from "../../components/Page";
import React from "react";
import { PricesProvider } from "../../contexts/PricesContext";
import { kovanFarms, mainNetFarms } from "../../web3Utils/farmConfigs";
import { FarmsProvider } from "../../contexts/FarmsContext";
import FarmsList from "../../components/Farms/FarmList";
import DefaultMainHeading from "../../components/Typography/DefaultMainHeading";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";

const styles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "transparent",
    alignContent: "center",
    justifyItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: 0,
    //height: '100%',
  },
  announcementBox: {
    // spacing
    marginTop: "1em",
    marginBottom: "1em",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column",
  },
  announcementText: {
    width: "100%",
    textAlign: "center",
    color: theme.palette.text.primary,
    fontSize: 22,
  },
  card: {
    backgroundColor: "transparent",
    padding: 0,
  },
}));

const FarmsView = () => {
  const classes = styles();

  return (
    <Page className={classes.root} title={"CORSAC Farms"}>
      <Grid
        container
        style={{ marginBottom: "1em" }}
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={10} md={8} className={classes.announcementBox}>
          <DefaultMainHeading>Earn CORSAC</DefaultMainHeading>
        </Grid>
      </Grid>

      {/*Wallet Balance*/}
      <Grid
        container
        item
        xs={12}
        className={classes.card}
        justifyContent="center"
        alignItems="center"
      >
        <PricesProvider
          farmConfig={
            process.env.REACT_APP_NETWORK_NAME === "kovan"
              ? kovanFarms
              : mainNetFarms
          }
        >
          <FarmsProvider
            farmConfig={
              process.env.REACT_APP_NETWORK_NAME === "kovan"
                ? kovanFarms
                : mainNetFarms
            }
          >
            <FarmsList />
          </FarmsProvider>
        </PricesProvider>
      </Grid>

      <Box style={{ minHeight: 30 }}></Box>
    </Page>
  );
};

export default FarmsView;
